import MojitoCore from 'mojito/core';
import { createSlice } from '@reduxjs/toolkit';

const reduxInstance = MojitoCore.Services.redux;

/**
 * Defines the state of the acca bar.
 *
 * @typedef AccaBarState
 *
 * @property {boolean} accumulatorEnabled - True if the acca bar should display the accumulator.
 * @property {boolean} betBuilderEnabled - True if the acca bar should display the Bet Builder.
 * @memberof Mojito.Modules.AccaBar
 */

/**
 * The name of the acca bar store. Will be used to register in global redux store.
 *
 * @constant
 * @type {string}
 * @memberof Mojito.Modules.AccaBar
 */
export const STORE_KEY = 'modules/accaBar';

export const initialState = {
    accumulatorEnabled: false,
    betBuilderEnabled: false,
};

export const { reducer, actions } = createSlice({
    name: 'accaBar',
    initialState,
    reducers: {
        configure(state, { payload }) {
            state.accumulatorEnabled = payload.accumulatorEnabled;
            state.betBuilderEnabled = payload.betBuilderEnabled;
        },
        reset() {
            return initialState;
        },
    },
});

/**
 * AccaBar related actions.
 *
 * @module AccaBar
 * @name actions
 * @memberof Mojito.Modules.AccaBar
 */

/**
 * Configure if the acca bar renders bet builder and accumulator.
 *
 * @function configure
 * @type {Mojito.Core.Services.redux.ActionCreator}
 * @param {{accumulatorEnabled: boolean, betBuilderEnabled: boolean}} value - Enable or disable accumulator and bet builder.
 *
 * @memberof Mojito.Modules.AccaBar.actions
 */

/**
 * Reset the acca bar state to initial value.
 *
 * @function reset
 * @type {Mojito.Core.Services.redux.ActionCreator}
 *
 * @memberof Mojito.Modules.AccaBar.actions
 */

reduxInstance.injectReducer(STORE_KEY, reducer);
